import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';
import DriverFine from './driver-fine.jsx';

export default class DriversFines extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drivers_fine_accounts:  null,
      isLoading: false,
      url: props.url || '/api/v1/portal/drivers/fines',
    };


    this.getDriversFines();
  }

  getDriversFines() {
    let url = this.state.url;
    return fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer '+window.api_token
        ,"Accept": 'application/json'
      },
    }).
    then((responseText) => {
      let response = responseText.json();
      response.then((driversExcessAccountsJson) => {
        this.setState({
          drivers_fine_accounts: driversExcessAccountsJson,
          isLoading: false,
        });
      });
    });
  }

  render() {
    let DriversFines = [];

    if (this.state.drivers_fine_accounts &&
        this.state.drivers_fine_accounts.length > 0) {
        this.state.drivers_fine_accounts.forEach(
          function(i) {
            DriversFines.push(
              <DriverFine
                key={'drivers-fines-'+i.id}
                data={i}
              />);
          }
       );
    }
    return (
      <div>
      {
        this.state.isLoading ?
        (<div className="loading-box">
          <span className="add-loading-text">
            <i className="fa fa-spinner fa-pulse"></i>
          </span>
        </div>) :
          <div>{DriversFines}</div>
      }
      </div>
    );
  }
}

if (document.getElementById(
  'react-component-g4-logistics-portal-drivers-fines')) {
  ReactDOM.render(
    <DriversFines
      url = {"/api/v1/portal/drivers/fines"}
      message_if_none = 'Excessses not found or available for viewing.'
    />,
    document.getElementById(
      'react-component-g4-logistics-portal-drivers-fines'
    )
  );
}
